import { render, staticRenderFns } from "./CACG1130.vue?vue&type=template&id=04d7b1f8&scoped=true"
import script from "./CACG1130Controller.ts?vue&type=script&lang=ts&external"
export * from "./CACG1130Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CACG1130.vue?vue&type=style&index=0&id=04d7b1f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d7b1f8",
  null
  
)

export default component.exports